import { array, intersect, nullish, object, pipe, transform } from 'valibot'
import { booleanData, richTextData, singleLineData } from '~/utils/crystallize/component-schemas'
import { crystallizeDocumentSchema } from '~/utils/crystallize/document'
import { contentBlockPiece } from '~/utils/crystallize/pieces'

export const layoutSchema = crystallizeDocumentSchema(
  'layout',
  object({
    footerCta: nullish(
      intersect([
        contentBlockPiece,
        object({
          subtitle: nullish(singleLineData),
        }),
      ]),
    ),

    headerCta: nullish(
      pipe(
        array(object({ show: nullish(booleanData), title: nullish(singleLineData), text: nullish(richTextData) })),
        // Non-repeatable chunk, so just get the first one
        transform(it => it[0]),
      ),
    ),
  }),
)
